/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AndroidApiHeadersHolder } from '../models/AndroidApiHeadersHolder';
import type { EnrollmentInitRequest } from '../models/EnrollmentInitRequest';
import type { EnrollmentStatusResponse } from '../models/EnrollmentStatusResponse';
import type { SignedResponse } from '../models/SignedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BulkEnrollmentControllerService {
    /**
     * @returns SignedResponse OK
     * @throws ApiError
     */
    public static initEnrollment({
        requestBody,
    }: {
        requestBody: EnrollmentInitRequest,
    }): CancelablePromise<SignedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/enrollment/init',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SignedResponse OK
     * @throws ApiError
     */
    public static initEnrollmentSigned({
        requestBody,
    }: {
        requestBody: EnrollmentInitRequest,
    }): CancelablePromise<SignedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/enrollment/signed/init',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EnrollmentStatusResponse OK
     * @throws ApiError
     */
    public static getEnrollmentStatusSigned({
        imei,
    }: {
        imei: string,
    }): CancelablePromise<EnrollmentStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/enrollment/signed/{imei}/status',
            path: {
                'imei': imei,
            },
        });
    }
    /**
     * @returns SignedResponse OK
     * @throws ApiError
     */
    public static challengeEnrollment({
        androidHeaders,
        imei,
        model,
    }: {
        androidHeaders: AndroidApiHeadersHolder,
        imei: string,
        model: string,
    }): CancelablePromise<SignedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/enrollment/{imei}/challenge',
            path: {
                'imei': imei,
            },
            query: {
                'androidHeaders': androidHeaders,
                'model': model,
            },
        });
    }
    /**
     * @returns EnrollmentStatusResponse OK
     * @throws ApiError
     */
    public static getEnrollmentStatus({
        imei,
    }: {
        imei: string,
    }): CancelablePromise<EnrollmentStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/enrollment/{imei}/status',
            path: {
                'imei': imei,
            },
        });
    }
}
